import { render } from "./IndividualClasses.vue?vue&type=template&id=76caf4d3&scoped=true&ts=true"
import script from "./IndividualClasses.vue?vue&type=script&lang=ts"
export * from "./IndividualClasses.vue?vue&type=script&lang=ts"

import "./IndividualClasses.vue?vue&type=style&index=0&id=76caf4d3&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76caf4d3"]])

export default __exports__